export const mergeSearchBootstrappedAdditionalContext = (
	additionalContext: Record<string, unknown> | undefined,
	source: string | undefined,
): Record<string, unknown> | undefined =>
	source === 'quickFindChatIntentRouter'
		? {
				...additionalContext,
				searchBootstrapped: true,
			}
		: additionalContext;
